import { useCallback, useEffect, useState } from 'react';
import { isViewMode, ViewMode } from './viewMode';
import { ViewModeConstants } from '../../constants/ViewModeConstants';
import { getRoles } from '../tokenUtils';

export function useViewMode(key: string, initial: ViewMode = ViewModeConstants.DATA_CARDS) {
    // Namespace by role so admin/member preferences don't conflict (important for impersonation)
    const roles = getRoles();
    const rolePrefix = roles?.includes('Admin') ? 'admin' : 'member';
    const storageKey = `view:${rolePrefix}:${key}`;

    const [view, setView] = useState<ViewMode>(() => {
        if (typeof window === 'undefined') return initial;
        const qp = new URLSearchParams(window.location.search).get('view');
        if (isViewMode(qp)) return qp;
        const ls = localStorage.getItem(storageKey);
        return isViewMode(ls) ? ls : initial;
    });

    // persist
    useEffect(() => {
        if (typeof window === 'undefined') return;
        localStorage.setItem(storageKey, view);
        const url = new URL(window.location.href);
        url.searchParams.set('view', view);
        window.history.replaceState({}, '', url); // no history spam
    }, [storageKey, view]);

    const toggle = useCallback(
        () => setView(v => (v === ViewModeConstants.DATA_CARDS ? ViewModeConstants.TABLE : ViewModeConstants.DATA_CARDS)),
        []
    );

    // keyboard: press "t" to toggle
    useEffect(() => {
        const onKey = (e: KeyboardEvent) => { if (e.key.toLowerCase() === 't') toggle(); };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [toggle]);

    return { view, setView, toggle };
}
